import { connect } from 'react-redux';
import { List } from 'immutable';
import PartnershipAccountAccessTabsMembersForm from '../components/PartnershipAccountAccessTabsMembersForm';

import {
  updatePartnershipAccountAccessTabsMembers,
  partnershipAccountAccessTabsMembersFormDestroy,
} from '../../../../../state/modules/partnershipAccount/actions';
import storage from '../../../../../lib/Storage';
import { findStorageType } from '../../../../../lib/Auth';

const inputs = List(['access_role_admin_tabs_members']);

const mapStateToProps = (state) => {
  const data = {},
    errors = {};
  for (const val of inputs.values()) {
    data[val] = state.partnershipAccount.getIn(
      ['data', val],
      ['access_role_admin_tabs_members'].includes(val) ? {} : null
    );
    if (
      state.partnershipAccount.getIn(['accessTabsMembersForm', 'errors', val])
    ) {
      errors[val] = state.partnershipAccount.getIn([
        'accessTabsMembersForm',
        'errors',
        val,
      ]);
    }
  }

  return {
    activeId: storage.get(findStorageType(), 'partnershipId'),
    isLoading: state.partnershipAccount.get('isLoading'),
    isSubmitting: state.partnershipAccount.get('isSubmittingAccessTabsMembers'),
    success: state.partnershipAccount.getIn([
      'accessTabsMembersForm',
      'success',
    ]),
    data: data,
    errors: errors,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    submit: (partnershipId, data, cb) => {
      dispatch(
        updatePartnershipAccountAccessTabsMembers(partnershipId, data, cb)
      );
    },
    formDestroy: (formState) => {
      dispatch(partnershipAccountAccessTabsMembersFormDestroy(formState));
    },
  };
};

const PartnershipAccountAccessTabsMembersFormContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(PartnershipAccountAccessTabsMembersForm);

export default PartnershipAccountAccessTabsMembersFormContainer;
